module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h1', {
    staticClass: "downloaarticle-main-title"
  }, [_vm._v("Selamat!")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Anda telah mengunduh Aplikasi All Football, yang merupakan versi terbaru dari situs web ini dan akan memberikan pengalaman penggunaan yang lebih baik.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("1. Unduh aplikasi")]), _vm._v(" "), (!_vm.is_opreamini) ? _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Jika Anda secara tidak sengaja membatalkan unduhan, Anda dapat klik tautan di bawah ini untuk mengunduh kembali.\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "download-btn",
    attrs: {
      "src": require("../assets/download/download_btn.png")
    },
    on: {
      "click": _vm.jumpUrl
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/download/download_pic1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("2. Atur pengaturan telepon")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/download/download_pic2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("3. Tidak berhasil")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/download/download_pic3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_c('b', {
    staticClass: "download-article-bold"
  }, [_vm._v("Berikut adalah beberapa petunjuk tentang cara menginstal aplikasi kami.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Jika muncul peringatan biasa tentang kemungkinan kerusakan perangkat, konfirmasi "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"OK\"")]), _vm._v(" - Kami menjamin bahwa aplikasi kami pasti tidak akan merusak perangkat Anda.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Anda akan menemukan aplikasi yang diunduh di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifikasi\"")]), _vm._v(" atau di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Unduhan\"")]), _vm._v(" folder. Klik pada itu, pilih "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Instal\"")]), _vm._v(" dan konfirmasi.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Anda akan menemukan aplikasi yang diunduh di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifikasi\"")]), _vm._v(" atau di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Unduhan\"")]), _vm._v(" folder. Klik pada itu, pilih "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Instal\"")]), _vm._v(" dan konfirmasi.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-bottom"
  }, [_c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("Tidak berhasil?")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n            Coba lagi mengikuti petunjuk di atas. Atau unduh versi aplikasi terbaru dari "), _c('a', {
    attrs: {
      "href": "https://at.umeng.com/SbK5Lf"
    }
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("Google_Play")])]), _vm._v(".\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02911806","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppDownload.vue
// module id = 805
// module chunks = 13